<template>
    <div>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-7">
                        <h1 class="product-detail__title">
                            {{ currentVariation | itemName }}
                        </h1>
                        <slot name="image-carousel"></slot>

                        <div v-if="$store.state.viewport.isLg || $store.state.viewport.isXl">
                            <slot name="crosssellingbasket"></slot>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-5">
                        <div class="product-detail">
                            <!-- START SINGLEITEM_DETAILS SCROLL => v-stick-in-parent-->
                            <div class="product-detail__producer" v-if="currentVariation.filter.hasManufacturer">
                                <a class="text-dark" v-if="currentVariation.item.manufacturer.logo" :href="currentVariation.item.manufacturer.url" :title="currentVariation.item.manufacturer.externalName" >
                                    <img :src="currentVariation.item.manufacturer.logo">
                                </a>
                                <span v-else>
                                    {{ currentVariation.item.manufacturer.externalName }}
                                </span>
                            </div>

                            <slot name="tag-list"></slot>

                            <slot name="before-price"></slot>

                            <div class="product-detail__property-list" v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                                <order-property-list></order-property-list>
                            </div>

                            <!--<graduated-prices></graduated-prices>-->

                            <item-price :show-cross-price="isRecommendedPriceActive" :show-net-price="showNetPrices"></item-price>

                            <slot name="after-price"></slot>


                            <slot name="additional-content-after-vat"></slot>


                            <item-availability class="product-detail__availability"></item-availability>

                            <p class="product-detail__short-description"
                               v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''"
                               v-html="currentVariation.texts.shortDescription">
                            </p>

                            <!-- Variation -->
                            <div class="product-detail__variation" v-if="attributes.length || Object.keys(units).length">
                                <variation-select></variation-select>
                            </div>
                            <!-- /Variation -->


                            <!-- Item Bundle -->
                            <div class="product-detail__bundle">
                                <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'" :bundle-type="currentVariation.variation.bundleType" :bundle-components="currentVariation.bundleComponents"></item-bundle>
                            </div>
                            <!-- /Item Bundle -->

                            <slot name="before-add-to-basket"></slot>

                            <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                                {{ $translate("Ceres::Template.singleItemSetInfo") }}
                            </div>

                            <div v-else class="product-detail__add-to-basket form-row align-items-center">
                                <add-to-basket
                                        class="col"
                                        :variation-id="currentVariation.variation.id"
                                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                        :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                        :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
										:has-order-properties="currentVariation.hasOrderProperties"
										:has-required-order-property="currentVariation.hasRequiredOrderProperty"
                                        :use-large-scale="false"
                                        :show-quantity="true"
                                        :item-url="currentVariation | itemURL"
                                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                        :has-price="currentVariation | hasItemDefaultPrice"
                                    >
                                </add-to-basket>
                                <!-- v-if="isWishListEnabled" -->
                                <div  class="product-detail-wishlist col-auto">
                                    <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                                </div>
                            </div>

                            <slot name="after-add-to-basket"></slot>
                            <slot name="additional-content-after-add-to-basket"></slot>

                            <div class="row mt-2">
                                <div class="col">
                                    <span class="product-detail__id">
                                        <b>{{ $translate("Ceres::Template.singleItemNumber") }}:</b>
                                        {{ currentVariation.variation.number }}
                                    </span>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col">
                                    <slot name="payment-list"></slot>
                                </div>
                            </div>

                            <div v-if="$store.state.viewport.isMobile">
                                <slot name="crosssellingbasket"></slot>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row product-detail-tabs__row">
                    <div class="col-12 col-lg-10">
                        <!-- ITEM DESCRIPTION -->
                        <div class="product-detail-tabs">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item" v-if="isDescriptionTabActive">
                                    <a class="nav-link active" data-toggle="tab" :href="'#details-' + currentVariation.variation.id" role="tab">{{ $translate("Ceres::Template.singleItemDescription") }}</a>
                                </li>

                                <li class="nav-item" v-if="isTechnicalDataTabActive">
                                    <a :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }" class="nav-link" data-toggle="tab" :href="'#data-' + currentVariation.variation.id" role="tab">{{ $translate("Ceres::Template.singleItemTechnicalData") }}</a>
                                </li>

                                <li class="nav-item" v-if="isLoggedIn && b2bClass == 2">
                                    <a :class="{ 'active': !isDescriptionTabActive && !isTechnicalDataTabActive }" class="nav-link" data-toggle="tab" href="#assessments-details" role="tab">{{ $translate("Ceres::Template.singleItemMoreDetails") }}</a>
                                </li>

                                <template v-if="currentVariation.variationProperties">
                                    <template v-for="propertyGroup in currentVariation.variationProperties">
                                        <template v-for="property in propertyGroup.properties" v-if="property.id === 5">
                                            <li class="nav-item">
                                                <a :class="{ 'active': !isDescriptionTabActive && !isTechnicalDataTabActive }" class="nav-link" data-toggle="tab" href="#keyfacts" role="tab">{{ $translate("ODKleinMore::Template.tabKeyfacts") }}</a>
                                            </li>
                                        </template>
                                    </template>
                                </template>

                                <slot name="add-detail-tabs"></slot>
                            </ul>

                            <div class="tab-content overflow-hidden">
                                <div class="tab-pane active" :id="'details-' + currentVariation.variation.id" role="tabpanel" v-if="isDescriptionTabActive">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <div class="tab-content__desc" v-html="currentVariation.texts.description">
                                            </div>
                                        </div>
                                        <div class="offset-md-1 col-md-3">

                                            <span class="product-detail__id">
                                                <b>{{ $translate("Ceres::Template.singleItemNumber") }}:</b>
                                                {{ currentVariation.variation.number }}
                                            </span>
                                            <p class="product-detail__short-description"
                                               v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''"
                                               v-html="currentVariation.texts.shortDescription">
                                            </p>
                                            <template v-for="prop in varProps" v-if="isLoggedIn && b2bClass == 2">
                                                <div class="more-infos" v-if="prop.id == 30">
                                                    <strong>{{ $translate("ODKleinMore::Template.moreInfosHeadline") }}</strong>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                                                    </svg> <a :href="'https://cdn02.plentymarkets.com/0fzvjq1iz403/propertyItems/' + prop.values.value" target="_blank">{{ $translate("ODKleinMore::Template.moreInfosDownload") }} </a>
                                                </div>
                                            </template>

                                        </div>
                                    </div>
                                </div>

                                <div :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }" class="tab-pane overflow-auto" :id="'data-' + currentVariation.variation.id" role="tabpanel" v-if="isTechnicalDataTabActive">
                                    <div class="tab-content__desc" v-html="currentVariation.texts.technicalData">
                                    </div>
                                </div>

                                <div :class="{ 'active': !isDescriptionTabActive && !isTechnicalDataTabActive }" class="tab-pane overflow-auto" id="assessments-details" role="tabpanel">
                                    <div class="tab-content__desc">
                                        <table class="table table-striped table-hover table-sm">
                                            <tbody>
                                            <tr v-if="itemConfig.includes('item.id') || itemConfig.includes('all')">
                                                <td>{{ $translate("Ceres::Template.singleItemId") }}</td>
                                                <td>{{ currentVariation.item.id }}</td>
                                            </tr>

                                            <tr v-if="currentVariation.item.condition && currentVariation.item.condition.names.name !== '' && (itemConfig.includes('item.condition') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemCondition") }}</td>
                                                <td>{{ currentVariation.item.condition.names.name }}</td>
                                            </tr>

                                            <tr v-if="itemConfig.includes('item.age_rating') || itemConfig.includes('all')">
                                                <td>{{ $translate("Ceres::Template.singleItemAge") }}</td>
                                                <td>{{ currentVariation.item.ageRestriction | ageRestriction }}</td>
                                            </tr>

                                            <tr v-if="currentVariation.variation.externalId !== '' && (itemConfig.includes('item.external_id') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemExternalVariationId") }}</td>
                                                <td>{{ currentVariation.variation.externalId }}</td>
                                            </tr>

                                            <tr v-if="currentVariation.variation.model !== '' && (itemConfig.includes('item.variation_model') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemModel") }}</td>
                                                <td>{{ currentVariation.variation.model }}</td>
                                            </tr>

                                            <tr v-if="currentVariation.filter.hasManufacturer && currentVariation.item.manufacturer.externalName !== '' && (itemConfig.includes('item.manufacturer') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemManufacturer") }}</td>
                                                <td>{{ currentVariation.item.manufacturer.externalName }}</td>
                                            </tr>

                                            <tr v-if="currentVariation.item.producingCountry && currentVariation.item.producingCountry.names.name !== '' && (itemConfig.includes('item.producerCountry') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemManufacturingCountry") }}</td>
                                                <td>{{ currentVariation.item.producingCountry.names.name }}</td>
                                            </tr>

                                            <tr v-if="currentVariation.unit && (itemConfig.includes('item.variationBase_content') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemContent") }}</td>
                                                <td>{{ currentVariation.unit.content }} {{ currentVariation.unit.names.name }}</td>
                                            </tr>

                                            <tr v-if="currentVariation.variation.weightG !== '' && (itemConfig.includes('item.weightG') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemWeight") }}</td>
                                                <td>{{ currentVariation.variation.weightG }} g</td>
                                            </tr>

                                            <tr v-if="currentVariation.variation.weightNetG !== '' && (itemConfig.includes('item.weightNetG') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemNetWeight") }}</td>
                                                <td>{{ currentVariation.variation.weightNetG }} g</td>
                                            </tr>

                                            <tr v-if="itemConfig.includes('item.variation_dimensions') || itemConfig.includes('all')">
                                                <td>{{ $translate("Ceres::Template.singleItemDimensions") }}</td>
                                                <td>
                                                    <span>{{ currentVariation.variation.lengthMM }}</span>&times;<!--
                                                --><span>{{ currentVariation.variation.widthMM }}</span>&times;<!--
                                                --><span>{{ currentVariation.variation.heightMM }}</span> mm
                                                </td>
                                            </tr>

                                            <tr v-if="currentVariation.variation.customsTariffNumber !== '' && (itemConfig.includes('variation.customs_tariff_number') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemCustomsTariffNumber") }}</td>
                                                <td>{{ currentVariation.variation.customsTariffNumber }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div :class="{ 'active': !isDescriptionTabActive && !isTechnicalDataTabActive }" class="tab-pane overflow-auto" id="keyfacts" role="tabpanel">
                                    <div class="tab-content__desc">
                                        <template v-if="currentVariation.variationProperties">
                                            <div v-for="propertyGroup in currentVariation.variationProperties" class="properties__wrapper">
                                                <div v-for="property in propertyGroup.properties" class="properties" v-if="property.id === 5">
                                                    <div class="properties__property-wrapper">
                                                        <!-- <strong v-if="property.names" class="properties__property-name">{{property.names.name}}</strong>-->
                                                        <span v-if="property.values" v-html="property.values.value" class="properties__property-value"></span>
                                                    </div>
                                                </div>

                                                <div v-for="property in propertyGroup.properties" class="properties" v-if="property.id === 6">
                                                    <div class="properties__property-wrapper">
                                                        <!-- <strong v-if="property.names" class="properties__property-name">{{property.names.name}}</strong>-->
                                                        <span v-if="property.values" v-html="property.values.value" class="properties__property-value"></span>
                                                    </div>
                                                </div>

                                                <div v-for="property in propertyGroup.properties" class="properties" v-if="property.id === 7">
                                                    <div class="properties__property-wrapper">
                                                        <!-- <strong v-if="property.names" class="properties__property-name">{{property.names.name}}</strong>-->
                                                        <span v-if="property.values" v-html="property.values.value" class="properties__property-value"></span>
                                                    </div>
                                                </div>

                                                <div v-for="property in propertyGroup.properties" class="properties" v-if="property.id === 8">
                                                    <div class="properties__property-wrapper">
                                                        <!-- <strong v-if="property.names" class="properties__property-name">{{property.names.name}}</strong>-->
                                                        <span v-if="property.values" v-html="property.values.value" class="properties__property-value"></span>
                                                    </div>
                                                </div>

                                                <div v-for="property in propertyGroup.properties" class="properties" v-if="property.id === 9">
                                                    <div class="properties__property-wrapper">
                                                        <!-- <strong v-if="property.names" class="properties__property-name">{{property.names.name}}</strong>-->
                                                        <span v-if="property.values" v-html="property.values.value" class="properties__property-value"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>

                                <slot name="add-detail-tabs-content"></slot>
                            </div>
                        </div>
                        <!-- ./ITEM DESCRIPTION -->
                    </div>

                </div>

                <slot name="item-list-container"></slot>
                <slot name="feedback-container"></slot>
            </div>
        </slot>
    </div>
</template>

<script>
import { get } from "ceres/app/helper/get";
import { isNullOrUndefined } from "ceres/app/helper/utils";
import {mapGetters, mapState} from "vuex";

export default {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object
    },

    provide()
    {
        return {
            itemId: this.$props.itemId
        }
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    computed:
    {

        pluginPath(){
            return App.pluginPath;
        },
        itemConfig()
        {
            return App.config.item.itemData;
        },

        varProps(){
            let propArr = [];
            for(let key in this.currentVariation.variationProperties){
                for(let innerKey in this.currentVariation.variationProperties[key].properties){
                    propArr.push(this.currentVariation.variationProperties[key].properties[innerKey]);
                }
            }

            return propArr;
        },

        isDescriptionTabActive()
        {
            return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.description.length;
        },

        isRecommendedPriceActive()
        {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive()
        {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId()
        {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive()
        {
            return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties()
        {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties()
        {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },

        isItemSet() {
          return this.$store.state.items.isItemSet;
        },

        ...mapGetters([
            "isLoggedIn"
        ]),

        ...mapState({
            userData: state => state.user.userData
        }),

        b2bClass()
        {
            if (this.isLoggedIn){
                return this.userData.classId;
            }
        }
    },

    created()
    {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId:             this.itemId,
                attributes:         this.attributesData,
                variations:         this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey:           this.afterKey
            });
          this.initBundleHandler();


            if (this.isItemSet)
            {
                this.$store.dispatch("initSetComponents", this.itemData);
            }
        })

        // listen for variation change to hydrate all children lazy-hydrate components
        document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
    },

  methods:
      {
        initBundleHandler()
        {
          let that = this;
          setTimeout(function()
          {
            if (!!document.querySelector(".single-crossselling"))
            {
                /*
              let items = document.querySelectorAll(".single-crossselling__item");

              for (let key in items)
              {
                if (items.hasOwnProperty(key))
                {
                  items[key].addEventListener("click", function(event)
                  {
                    event.stopPropagation();
                    this.querySelector(".single-crossselling__item-info").classList.toggle("is-open");
                    this.classList.toggle("is-open");

                    let itemId = this.closest(".single-crossselling__item").dataset.itemid;
                    let varId = this.closest(".single-crossselling__item").dataset.id;
                    let varData = JSON.parse(this.closest(".single-crossselling__item").dataset.data);
                    let itemData = JSON.parse(this.closest(".single-crossselling__item").dataset.item);
                    let itemDataData = varData.data;
                    let documents = [];
                    documents.push(varData);
                    let itemDataDoc = {documents: documents}

                    console.log(itemDataDoc.documents[0]);
                    console.log(itemData);

                    let varSelectData = null;

                    ApiService.get("/rest/ODKleinMore/item-variation-attributes-map?id=" + itemId)
                        .done(response =>
                        {
                          console.log(response);

                          // TODO: response.attributeMap.attributes[id].name / .values[valueId] -> name
                          // response.variationMap[key].variationId anhand response.variationMap[key].attributes[keyinner].attributeValueId
                        })
                  });
                }
              }
              let indicatorsAdd = document.querySelectorAll(".single-crossselling__indicator--add");

              for (let key in indicatorsAdd)
              {
                if (indicatorsAdd.hasOwnProperty(key))
                {
                  indicatorsAdd[key].addEventListener("click", function(event)
                  {
                    event.stopPropagation();
                    this.classList.add("d-none");
                    this.closest(".single-crossselling__item").querySelector(".single-crossselling__indicator--remove").classList.remove("d-none");
                    this.closest(".single-crossselling__item").classList.add("is-selected");
                  });
                }
              }

              let indicatorsRemove = document.querySelectorAll(".single-crossselling__indicator--remove");

              for (let key in indicatorsRemove)
              {
                if (indicatorsRemove.hasOwnProperty(key))
                {
                  indicatorsRemove[key].addEventListener("click", function(event)
                  {
                    event.stopPropagation();
                    this.classList.add("d-none");
                    this.closest(".single-crossselling__item").querySelector(".single-crossselling__indicator--add").classList.remove("d-none");
                    this.closest(".single-crossselling__item").classList.remove("is-selected");
                  });
                }
              }
              */
                let items = document.querySelectorAll(".single-crossselling__item");

              let showMore = document.querySelector(".single-crossselling__show-more");

              if (showMore !== null)
              {
                showMore.addEventListener("click", function(event)
                {
                  event.stopPropagation();

                  for (let innerKey in items)
                  {
                    if (items.hasOwnProperty(innerKey))
                    {
                      items[innerKey].classList.add("show-hidden-items");
                    }
                  }

                  this.classList.add("d-none");
                  document.querySelector(".single-crossselling__show-less").classList.remove("d-none");
                });
              }

              let showLess = document.querySelector(".single-crossselling__show-less");

              if (showLess !== null)
              {
                showLess.addEventListener("click", function(event)
                {
                  event.stopPropagation();

                  for (let innerKey in items)
                  {
                    if (items.hasOwnProperty(innerKey))
                    {
                      items[innerKey].classList.remove("show-hidden-items");
                    }
                  }

                  this.classList.add("d-none");
                  document.querySelector(".single-crossselling__show-more").classList.remove("d-none");
                });
              }
            }
          }, 250);
        },

        getDataField(field)
        {
            return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter)
        {
            if (!isNullOrUndefined(this.$options.filters[filter]))
            {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },

        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes)
        {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate")
                {
                    component.hydrate();
                }
                else if (component.$children.length)
                {
                    this.hydrateChildren(component.$children);
                }
            })
        }
    }
}
</script>
